import PropTypes from 'prop-types';
import React from 'react';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';

import PuppyPricing from '../shared/PuppyPricing';
import WhatsIncluded from '../shared/WhatsIncluded';

export default function PricingMobileMenu({ isOpen, closeModal }) {
  return (
    <FixedTooltipPortal
      className="PricingMobileMenu ph5 bg-white no-scrollbars b--transparent"
      isVisible={isOpen}
      style={{ maxHeight: '85vh' }}
      onCloseClick={() => closeModal()}
    >
      <PuppyPricing />
      <WhatsIncluded className="pt8" />
    </FixedTooltipPortal>
  );
}

PricingMobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};
